module.exports = __webpack_public_path__ + "static/media/delete-icon.fdc306a2.svg";